module.exports = __webpack_public_path__ + "static/img/4.1035b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/4.png
// module id = DhLE
// module chunks = 0